module.exports = __webpack_public_path__ + "img/shivaaura2.ebc23ad0.png";